<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productMain_tit" v-if="statusData.titleStatus === true"><!-- travel_title_area -->
        <h1>{{ travelTitle }} <span>· (주)행복을주는사람들이 추천하는 꼭! 가볼만한 여행상품들을 만나보세요.</span></h1>
      </div>
      <div class="travel-banner">
        <swiper :options="statusData.travelSwiperOptions">
          <swiper-slide
            v-for="item in statusData.travelRecommendProducts"
            :key="item.travel_product_ID">
            <a :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID">
              <img :src="item.travel_product_img1" :alt="item.travel_product_name" />
              <div class="travel-banner-slider">
                <h2>{{ item.travel_product_name }}</h2>
                <p>{{ Number(item.schedule_price_min).toLocaleString() }}원 ~</p>
              </div>
            </a>
          </swiper-slide>
          <div class="travel_swiper_prev" slot="button-prev"/>
          <div class="travel_swiper_next" slot="button-next"/>
        </swiper>
      </div>

      <div class="hp_productMain_contentWrap"> <!-- travel_content -->
        <div class="hp_productMain_contentSidebar"><!-- travel_sidebar -->
          <div class="hp_productMain_contentMenuBox">
            <ul class="hp_productMain_contentMenu"><!-- travel_menu -->
              <li
                v-for="item in statusData.travelTypes"
                :key="item.travel_type_ID"
                @click="setTravelTypeID(item.travel_type_ID)"
                :class="{ 'hp_productMain_contentMenu_active': item.travel_type_ID === statusData.travelTypeID }">
                <a>
                  {{ item.travel_type_name }}
                </a>
              </li>
            </ul>
          </div>

          <div class="hp_productMain_contentKeywordBox">
            <p class="hp_productMain_contentKeyword_tit">HOT키워드<span>여행</span></p>
            <div class="hp_productMain_contentKeyword_tagBox"><!-- travel_tags -->
              <p
                  v-for="item in statusData.hotKeywordData"
                  :key="item.hot_keyword_ID"
                >
                <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(item.hot_keyword_name)}`">
                  #{{ item.hot_keyword_name }}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div class="hp_productMain_listWrap"> <!-- 메인 콘텐츠 전체 박스 -->
          <div class="hp_productMain_list_num">
            <span>{{statusData.totalCount}}개</span>의 상품이 등록되어 있습니다.
          </div> <!-- 갯수표시 -->

          <div class="hp_productMain_listBox">
            <a
              v-for="item in statusData.travelProducts"
              :href="'/TravelProductDetail?travelProductID=' + item.travel_product_ID"
              :key="item.travel_product_ID"> <!-- travel_card 목록 개별 -->
              <div class="hp_productMain_listImg">
                <img :src="item.travel_product_img1" alt="여행 메인 이미지" > <!-- travel_image 이미지 -->
              </div>
              <div class="hp_productMain_listInfo"> <!-- travel_info 글자 정보 -->
                <div class="hp_productMain_listInfo_tags"> <!-- travel_info_tags 글자정보 태그 -->
                  <span v-for="tag in JSON.parse(item.travel_product_tag)" :key="tag">
                    <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(tag)}`">
                      {{ tag }} <!-- 태그인거 이거 누르면 이거에 맞춰서 이동 -->
                    </a>
                  </span>
                </div>
                <div class="hp_productMain_listInfo_info">
                  <p class="hp_productMain_listInfo_infoTit">{{ item.travel_product_name }}</p> <!-- travel_title -->
                  <div class="hp_productMain_listInfo_infoIncluded"> <!-- travel-description -->
                    <p>포함내역</p>
                    <p>{{item.travel_product_included}}</p>
                  </div>
                  <p class="hp_productMain_listInfo_infoPrice">
                    <span>{{ Number(item.schedule_price_min).toLocaleString() }}</span>원 ~
                  </p>
                </div>
              </div>
            </a>
          </div>

          <ul class="hp_product_pagination"> <!--  travel_pagination 페지네이션 -->
            <li v-for="page in totalPages" :key="page" @click="setCurrentPage(page)" :class="{ active: statusData.currentPage === page }">
              {{ page }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_travel_product_recommend,
  get_travel_type_use_where,
  get_travel_product_homepage,
  get_hot_keyword_top10
} from '../../ETC/Axios.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'TravelProduct',
  components: {
    Header,
    Footer,
    Scroll,
    Swiper,
    SwiperSlide
  },
  setup () {
    return {
      statusData: ref({
        currentPage: 1,
        pageSize: 10, /* 한페이지에 보이는 수량 */
        totalCount: 0,
        hotKeywordData: [],
        titleStatus: true,
        travelSearchData: '',
        travelTypeID: '',
        travelTypeDivision: '',
        departureConfirmed: '0',
        travelRecommendProducts: [],
        travelTypes: [],
        travelProducts: [],
        travelSwiperOptions: { /* 메인 롤링 배너 */
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          navigation: {
            prevEl: '.travel_swiper_prev',
            nextEl: '.travel_swiper_next'
          },
          slidesPerView: 3
        }
      })
    }
  },
  computed: {
    travelTitle () {
      const titles = {
        '1': '국악와인열차',
        '2': '팔도장터열차',
        '3': '일반기차여행',
        '4': '버스/자유여행',
        '5': '섬/제주/해외여행'
      }
      return ` ${titles[this.statusData.travelTypeDivision]}`
    },
    totalPages () {
      return Math.ceil(this.statusData.totalCount / this.statusData.pageSize)
    }
  },
  methods: {
    loadTravelProducts (typeID, typeDivision, searchData, departureConfirmed, currentPage, pageSize) {
      get_travel_product_homepage(typeID, typeDivision, searchData, departureConfirmed, currentPage, pageSize)
        .then(result => {
          this.statusData.travelProducts = result.rows
          this.statusData.totalCount = result.total_count_rows[0].total_count
        })
    },
    setCurrentPage (page) {
      this.statusData.currentPage = page
      this.loadTravelProducts(
        this.statusData.travelTypeID,
        this.statusData.travelTypeDivision,
        this.statusData.travelSearchData,
        this.statusData.departureConfirmed,
        page,
        this.statusData.pageSize
      )
      window.scrollTo({ top: 0 })
    },
    setTravelTypeID (id) {
      this.statusData.travelTypeID = id
      this.loadTravelProducts(
        id,
        this.statusData.travelTypeDivision,
        this.statusData.travelSearchData,
        this.statusData.departureConfirmed,
        1,
        this.statusData.pageSize
      )
    }
  },
  mounted () {
    get_hot_keyword_top10().then(result => {
      this.statusData.hotKeywordData = result
    })
    if (this.$route.query.travelTypeDivision) {
      this.statusData.travelTypeDivision = this.$route.query.travelTypeDivision
      get_travel_product_recommend(
        this.statusData.travelTypeDivision
      ).then(result_data => {
        this.statusData.travelRecommendProducts = result_data
      })
      get_travel_type_use_where(this.statusData.travelTypeDivision).then(result_data => {
        this.statusData.travelTypes = result_data
      })
    }
    if (this.$route.query.travelSearchData) {
      this.statusData.travelSearchData = this.$route.query.travelSearchData
      this.statusData.titleStatus = false
    }
    if (this.$route.query.travelTypeID) {
      this.statusData.travelTypeID = +this.$route.query.travelTypeID
    }
    if (this.$route.query.departureConfirmed) {
      this.statusData.departureConfirmed = +this.$route.query.departureConfirmed
      this.statusData.titleStatus = false
    }
    this.loadTravelProducts(
      this.statusData.travelTypeID,
      this.statusData.travelTypeDivision,
      this.statusData.travelSearchData,
      this.statusData.departureConfirmed,
      this.statusData.currentPage,
      this.statusData.pageSize
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Travel/TravelProduct.vue